const ether = Math.pow(10, 18);
export const bnbToWei = bnb => BigInt(bnb * ether);